import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sd-dropdown-menu-item',
  standalone: true,
  templateUrl: './dropdown-menu-item.component.html',
  styleUrls: ['./dropdown-menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.active]': 'isActive()',
  },
})
export class DropdownMenuItemComponent {
  isActive = input(false);
}
